// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"106":"css/inwood","170":"css/app","492":"css/mah","703":"css/admin"}[chunkId] + ".css";
};